

<section style="overflow-y: scroll;height: 100%;">

  <div class="wrapper">
  <button type="button" class="add-boutton fa fa-search-plus" style="left: 70%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25%;  font-weight: normal;" name="Addfont" (click)="ZoomIn()"></button>
  <button type="button" class="add-boutton fa fa fa-search-minus" style="left: 74%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25% ;font-weight: normal;" name="Munesfont" (click)="ZoomOut()"></button>

  <button type="button" class="add-boutton" style="left: 83%;" [disabled]="disablepharnacy" name="Add" (click)="openDialog()">Add</button>
  </div>

<BR>
  <BR>

  <table style="left: 5%; width: 100%;">
    <tr *ngFor="let item of clinicalexamList; let i = index" style="font-size: {{wk_fontsize}};text-align: left;">
      <td>
        <div style="display: flex; justify-content: space-between; align-items: center;">  <div>
          <label style="font-weight: bold;">{{item.examdate}} {{item.username}}  </label>     <label for="">({{examlocationtext[i]}})</label>

        </div>
          <div>
            <button class="fa fa-pencil"  [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: green;" matTooltip="Edit" name="Add" (click)="EditCliniclExam(item)"></button>
            <button class="fa fa-trash" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: red;" matTooltip="Delete" name="Delete" (click)="MessegeDelete(item)"></button>
          </div>
        </div>
        <label>    performance status  :{{item.examperfstatus}}</label>
        <!-- <label><pre>{{item.examnotes}}</pre></label> -->
        <angular-editor
        [(ngModel)]="item.examnotes"
        [config]="editorConfigNoToolbar" style="border: none !important; box-shadow: none !important;"
    >

      </angular-editor>
        <br>
        <br>
      </td>
    </tr>
  </table>
</section>
